export const environment = {
    production: false,
    envName: 'qa',

    /* API constants */
    baseURL: 'https://beaconstacqa.mobstac.com/',
    reportingBaseURL: 'https://q.reporting.beaconstac.com/',
    apiBaseURL: 'https://q.api.beaconstac.com/',
    apiEndpoint: 'api/',
    apiVersion: '2.0',
    dbcDomain: 'q.smartcards.pro',

    // Auth0
    authOClientId: 'QLW4wvPmsqzdXl3B7b1EPS0JLM4umjFV',
    auth0Domain: 'authqa.uniqode.com',
    auth0URN: 'urn:auth0:bac-qa',
    mfaAudienceURL: 'https://bac-qa.auth0.com/mfa/',

    // Google Client OAuth 2.0
    oAuthClientId: '453571709589-42d64vs5rarfeon1j44votfhv5mfdeon',

    // Amplitude
    amplitudeAPIKey: '5397fd63881438cd7d4b3a7aeae05301',

    // Intercom
    intercomAppId: 'zpqzij6r',

    // Datadog
    DDApplicationId: '7a696fd4-5722-47af-9d9d-1bb0534015fb',
    DDClientToken: 'pub94aa2582abf8345f418e247e25fa0cbe',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    DDSite: 'datadoghq.com',
    DDService: 'dbc-pwa',
    redirectToDashboardCardList:
        'https://bac-qa.firebaseapp.com/digital-business-cards/my-cards/design-library',
    redirectToDashboard: 'https://bac-qa.firebaseapp.com/overview',
    dashboardUrl: 'https://dashboardqa.uniqode.com/',
    INDEX_DB_NAME: 'uniqode-pwa-cache',
    appleWalletPassBaseUrl: 'https://q.smartcards.pro/apple-passwallet/',
    googleWalletPassBaseUrl: 'https://q.smartcards.pro/google-passwallet/',

    // App Store URLs
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.uniqode.cards',
    appStoreUrl: 'https://apps.apple.com/us/app/uniqode-cards/id6747088345',
    mobileAppChotuLink: 'https://uniqode.chottu.link/cards-mobile-app?cards_app_nudge_source=pwa_mobile_landing_page',

    // LaunchDarkly
    launchDarklyClientID: '668f80aafcf1fa1041dedfe2'
};
